import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
var type = document.getElementById('root')?.getAttribute('type');
if (!type || !['full', 'search', 'map'].includes(type)) {
  type = 'full';
}
var language = document.getElementById('root')?.getAttribute('language');
if (!language || !['fr', 'en'].includes(language)) {
  language = 'fr';
}

root.render(
  <React.StrictMode>
    <App
      type={type}
      language={language}
      />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
